import { ComponentType } from "react";
import {
  ExtensionUiComponentType,
  useGetExtensionsUiComponentsQuery,
} from "../../../graphql/generated";
import ExtensionUIComponent, {
  ExtensionUIComponentProps,
} from "./ExtensionUIComponent";

type ExtensionUIComponentContainerProps = Omit<
  ExtensionUIComponentProps,
  "uiComponent"
> & {
  type: ExtensionUiComponentType;
  fallback?: ComponentType;
  fallbackProps?: Record<string, any>;
};

const ExtensionUIComponentContainer = ({
  type,
  ...props
}: ExtensionUIComponentContainerProps) => {
  const { data, isLoading, error } = useGetExtensionsUiComponentsQuery({
    type,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error loading extension UI component</div>;
  }

  const uiComponent = data?.extensionsUIComponents[0];

  if (!uiComponent) {
    return props.fallback ? (
      <props.fallback {...(props.fallbackProps ?? props.componentProps)} />
    ) : (
      <div>No UI component found</div>
    );
  }

  return <ExtensionUIComponent uiComponent={uiComponent} {...props} />;
};

export default ExtensionUIComponentContainer;
